import { render } from "./PartnerBrands.vue?vue&type=template&id=ad2d3822&scoped=true"
import script from "./PartnerBrands.vue?vue&type=script&lang=js"
export * from "./PartnerBrands.vue?vue&type=script&lang=js"

import "./PartnerBrands.vue?vue&type=style&index=0&id=ad2d3822&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad2d3822"]])

export default __exports__